'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import AboutHero from './components/AboutHero';
import FirmPhilosophy from './components/FirmPhilosophy';
import WorkingStyle from './components/WorkingStyle';
import { useLanguage } from '@/contexts/LanguageContext';

export default function About() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <AboutHero language={language} />
        <FirmPhilosophy language={language} />
        <WorkingStyle language={language} />
      </main>
      <Footer />
    </>
  );
}